module.exports = __webpack_public_path__ + "img/dashboard-profile-driver-question.54952fe9.svg";